import { CommonModule } from '@angular/common';
// Angular Imports
import { NgModule } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FlyoutLoggedinUserComponent } from '../../flyout/flyout-loggedin-user/flyout-loggedin-user.component';
import { FlyoutLoggedinUserModule } from '../../flyout/flyout-loggedin-user/flyout-loggedin-user.module';
// This Module's Components
import { BusinessUserComponent } from './business-user.component';

@NgModule({
  imports: [CommonModule, FlyoutLoggedinUserModule],
  declarations: [BusinessUserComponent],
  exports: [BusinessUserComponent],
  providers: [BsModalRef, BsModalService]
})
export class BusinessUserModule {}
